import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  SalesforceManagement_BusinessPartner_FullName: {
    name: 'SalesforceManagement_BusinessPartner_FullName',
    title: 'Business Partner',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      '/accounting/receivables-payables/{SalesforceManagement_BusinessPartner_Id}',
    openUrlInNewTab: false,
  },
  SalesforceManagement_BusinessPartner_Type: {
    name: 'SalesforceManagement_BusinessPartner_Type',
    title: 'Type',
    type: EnhancedTableHeaderType.Text,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        company: {
          name: 'company',
          title: 'Company',
          type: FormInputTypes.newselect,
          value: filterValues?.company || null,
          placeholder: 'Company',
          triggerUpdate: true,
          selectOptions: { ...lovs.company },
          canClearValue: true,
        },
        businessPartnerType: {
          name: 'businessPartnerType',
          title: 'Business Partner Type',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.businessPartnerType || null,
          placeholder: 'Business Partner Type',
          triggerUpdate: true,
          selectOptions: { ...lovs.businessPartnerType },
        },
      },
    },
  ];
  return newFilterSections;
}
